// extracted by mini-css-extract-plugin
module.exports = {"counter-pending-college-rsvps":"_2_ynTJIJMlWot5t5-H8DMJ"};